import React from "react";
import styled, { keyframes } from "styled-components";
import { TIME_TO_COMPLETE_IMAGE_WITH_PERFECT_SCORE } from "../../CoreLoop";

const GOOD_THRESHOLD = TIME_TO_COMPLETE_IMAGE_WITH_PERFECT_SCORE * 2;
const OK_THRESHOLD = TIME_TO_COMPLETE_IMAGE_WITH_PERFECT_SCORE * 3.5;

function rateTimeToComplete({ timeToComplete, success }) {
  if (!success) return "zucked up!";

  if (timeToComplete < GOOD_THRESHOLD) return "good zuck!";
  else if (timeToComplete < OK_THRESHOLD) return "ok zuck";
  else return "bad zuck!";
}

const FadeOutDropDown = keyframes`
  0% {
    opacity: 0;
    transform: translate(-50%, 0);
  }
  20% {
    opacity: 1;
    transform: translate(-50%, 25%);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, 200%);
  }
`;

const TimeToCompleteWrapper = styled.p`
  position: absolute;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
  font-size: 2rem;
  width: max-content;
  @media (min-width: 768px) {
    font-size: 2.5rem;
  }
  color: var(--color-indigo-900);
  font-family: monospace;
  text-shadow:
    2px 2px 0 var(--color-amber-500),
    4px 4px 4px var(--color-amber-500);
  background-color: var(--color-amber-400);
  padding: 0.15em 0.25em;
  border-radius: 16px;
  animation: ${FadeOutDropDown} 0.75s ease-in-out both;
  pointer-events: none;
`;

function TimeToCompletes({ timeToCompletes }) {
  return (
    <>
      {timeToCompletes.map((t, index) => {
        const timeToComplete = t.timeToComplete;
        const rating = rateTimeToComplete({
          timeToComplete,
          success: t.success,
        });
        return (
          <TimeToCompleteWrapper key={timeToComplete}>
            {rating}
          </TimeToCompleteWrapper>
        );
      })}
    </>
  );
}

export default TimeToCompletes;
